export default {"src":"/_next/static/media/watering-plant.colour.0be9eb1b.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};